import { useState } from "react";
import {
  Menu,
  MenuItem,
  NavContainer,
  NavLogo,
  ButtonContainer,
  Nav,
  MobileMenu,
} from "./NavbarElements";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Button from "../button/button";
import {
  MenuItem as MuiMenuItem,
  Menu as MuiMenu,
} from "@mui/material";
import { FiChevronDown, FiChevronUp, FiMenu } from "react-icons/fi";
import { GrFormClose } from "react-icons/gr";
import { PORTAL_BASE_URL } from "../../constants/defaultValues";

export default function Navbar() {
  const [open, setopen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const contactMenuOpen = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const location = useLocation();

  const toggleMenu = (e) => {
    e.preventDefault();
    setopen(!open);
  };

  const handleClicked = () => {
    setopen(!open);
  };
  const CheckLocation = (path) => {
    if (location.pathname === path) {
      return "active";
    }
  };
  return (
    <NavContainer>
      <Nav>
        <Link to="/">
          <NavLogo src="/img/logo.png" alt="" />
        </Link>
        <Menu>
          <MenuItem>
            <Link to={`/`} className={CheckLocation("/")}>
              For businesses{" "}
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to={`/bills`} className={CheckLocation("/bills")}>
              Pay bills
            </Link>
          </MenuItem>
          <MenuItem>
            <a
              href={`https://icadpay.com/developers/index.html`}
              className={CheckLocation("/docs")}
              target="_blank"
              rel="noreferrer"
            >
              API Documentation
            </a>
          </MenuItem>
          <MenuItem
            id="contact-button"
            aria-controls={contactMenuOpen ? "contact-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={contactMenuOpen ? "true" : undefined}
            onClick={handleClick}
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              cursor: "pointer",
              color: "#2b2c3e",
              fontSize: "14px",
              fontFamily: "Poppins",
            }}
          >
            Contact {contactMenuOpen ? <FiChevronUp /> : <FiChevronDown />}
          </MenuItem>
          <MuiMenu
            id="contact-menu"
            anchorEl={anchorEl}
            open={contactMenuOpen}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "contact-button",
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MuiMenuItem onClick={handleClose}>
              <Link to="/contact/support">Support</Link>
            </MuiMenuItem>
            <MuiMenuItem onClick={handleClose}>
              <Link to="/contact/sales">Sales</Link>
            </MuiMenuItem>
          </MuiMenu>
        </Menu>
        <ButtonContainer>
          <a href={`${PORTAL_BASE_URL}/user/login`} target="_blank" rel="noreferrer">
          <Button text={`Login`} />
          </a>
        </ButtonContainer>
      </Nav>
      <MobileMenu open={open}>
        <button className="menubtn" onClick={toggleMenu}>
          <FiMenu />
        </button>
        <div className="mobile_container">
          <button className="mobile_close" onClick={toggleMenu}>
            <GrFormClose />
          </button>
          <div className="mobile_menu">
            <div className="">
              <Link to="/bills" onClick={handleClicked}>
                <NavLogo src="/img/logo.png" alt="" />
              </Link>
            </div>
            <ul>
              <li className="">
                <Link to={`/`} onClick={handleClicked}>
                  For Businessess
                </Link>
              </li>
              <li className="">
                <Link to={`/bills`} onClick={handleClicked}>
                  Pay Bills{" "}
                </Link>
              </li>
              <li className="">
                <a
                  href={`https://icadpay.com/developers/index.html`}
                  onClick={handleClicked}
                  target="_blank"
                  rel="noreferrer"
                >
                  API Documentation{" "}
                </a>
              </li>
              <li className="">
                <Link to={`/contact/support`} onClick={handleClicked}>
                  Support{" "}
                </Link>
              </li>
              <li className="">
                <Link to={`/contact/sales`} onClick={handleClicked}>
                  Sales{" "}
                </Link>
              </li>
            </ul>
            <a href={`${PORTAL_BASE_URL}/user/login`} target="_blank" rel="noreferrer">
              <Button text={`Login`} />
            </a>
          </div>
        </div>
      </MobileMenu>
    </NavContainer>
  );
}
